import React from 'react';
import moment from 'moment-timezone';
import Icon from 'shared/components/Icon';
import CaretIcon from 'assets/images/caret.svg';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';
const {
  newEmployeeDashboard: { CLICK_DASHBOARD_CARD },
} = mixpanelEvents;

const SecondaryUpcomingWebinar = ({ upcomingWebinar }) => {
  const clickHandler = () => {
    mixpanelTrack(CLICK_DASHBOARD_CARD, {
      cardType: 'Webinar',
      cardTitle: upcomingWebinar.name,
    });
  };
  const { scheduledDate, name, encodedId } = upcomingWebinar;
  const date = moment(scheduledDate, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  return (
    <a
      href={`/webinars/${encodedId}`}
      id="following-webinar"
      onClick={clickHandler}
    >
      <div className="calendar employee-dashboard">
        <p className="month-name employee-dashboard">
          {date.format('MMMM').toUpperCase()}
        </p>
        <h3 className="day">{date.format('DD')}</h3>
      </div>

      <p className="webinar-title">{name}</p>

      <Icon className="caret-icon-dashboard" icon={CaretIcon} />
    </a>
  );
};

export default SecondaryUpcomingWebinar;
